import React, { Component } from 'react';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';

class Payment{
    constructor(sys_payment_type_id, amount, notes) {
        this.sys_payment_type_id = sys_payment_type_id;
        this.amount = amount;
        this.notes = notes;
        this.bk_payment_id = 0;
    }
}


@inject('userStore')
class ModalInvoicePayment extends Component {
    constructor(props){
        super(props);
        this.state = {
            payment_type_list:[],
            selectedInvoice:null,
            payment:new Payment("2", 0, '')
        }
        this.setAmount = this.setAmount.bind(this);
        this.setNotes = this.setNotes.bind(this);
        this.setPaymentType = this.setPaymentType.bind(this);
        this.setInvoice = this.setInvoice.bind(this);
        this.recordPayment = this.recordPayment.bind(this);
    }

    componentDidMount(){
        console.log(this.props.invoice)
        this.setState({
            selectedInvoice:this.props.invoice,
            payment_type_list:this.props.payment_type_list
        }, ()=>this.setInvoice(this.state.selectedInvoice));
    }

    setNotes(event){
        let payment = Object.assign({}, this.state.payment);    //creating copy of object
        payment.notes = event.target.value;
        this.setState({
            payment:payment
        })
    }

    setPaymentType(event){
        let payment = Object.assign({}, this.state.payment);    //creating copy of object
        payment.sys_payment_type_id = event.target.value;
        this.setState({
            payment:payment
        })
    }

    setAmount(event){
        let payment = Object.assign({}, this.state.payment);    //creating copy of object
        payment.amount = event.target.value;
        this.setState({
            payment:payment
        })
    }

    setInvoice(invoice){
        let payment = Object.assign({}, this.state.payment);    //creating copy of object
        payment.amount = invoice.due_amount;
        payment.bk_payment_id = invoice.bk_payment_id;
        this.setState({
            selectedInvoice:invoice,
            payment:payment,
        })
    }

    recordPayment(event){
        event.preventDefault();
        post('v2/save/record_payment', {
                bk_payment_id: this.state.payment.bk_payment_id,
                bk_invoice_id: this.state.selectedInvoice.id,
                amount:this.state.payment.amount,
                notes:this.state.payment.notes,
                sys_payment_type_id:this.state.payment.sys_payment_type_id
            }, {
                auth: {username: this.props.userStore.token}
            }).then((res) => {
              console.log(res.data);
              if (res.data.errors === 0){
                  this.props.notifyHandler.show(res.data.message, "success", 1000);
                  this.props.reloadHandler(res.data.invoice);
              }
          }).catch((error) => {
                console.log(error);
                return error;
          });
    }


  render() {
      if (!this.state.selectedInvoice) return <div className="alert alert-danger">Loading Invoice...</div>;
      const {selectedInvoice, payment_type_list, payment} = this.state;
      const {modalBackgroundClicked} = this.props;

    return (
    	<React.Fragment>
                <form className="card card-bordered mb-0">
                    <div className="card-header">
                        <h4 className="card-title"><strong>Record Payment</strong> - #{selectedInvoice.id}: {selectedInvoice.description}</h4>
                        <button type="button" className="close" onClick={modalBackgroundClicked} aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>
                    </div>                
                    <div className="card-body">
                        <div className="form-group">
                            <label>Amount Due</label>
                            <p className="form-control-plaintext">${selectedInvoice.due_amount}</p>
                        </div>
                        <div className="form-group">
                            <label>Payment Type</label>
                            <select className="form-control" value={payment.sys_payment_type_id} onChange={this.setPaymentType}>
                            {payment_type_list.map((type, index) =>
                                <option key={index} value={type.id}>{type.display_text}</option>
                            )}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Payment Amount</label>
                            <input className="form-control" type="text" value={payment.amount} onChange={this.setAmount}/>
                        </div>
                        <div className="form-group">
                            <label>Transaction Comments</label>
                            <input className="form-control" type="text" value={payment.notes} onChange={this.setNotes}/>
                        </div>
                    </div>
                    <footer className="card-footer text-right">
                        <div className="btn-group">
                            <button className="btn btn-light" onClick={modalBackgroundClicked}>Cancel</button>
                            <button className="btn btn-primary" onClick={(event) => this.recordPayment(event)}>Record</button>
                        </div>
                    </footer>
                </form>
        </React.Fragment>
    )
  }
}

export default ModalInvoicePayment;



// WEBPACK FOOTER //
// ./src/components/business/ModalInvoicePayment.js